import http from '@gp/utils/httpTS';

// 详情页头部信息
export const queryDetailHeader = (params: { studio_id: string }) => {
  return http.get('/api/v1/globalpedia_pc/studio/stu_basic_info', { params });
};

// 详情页Overview页签Key Infomation信息
export const queryDetailKeyInfomation = (params: { studio_id: string }): Promise<any> => {
  return http.get('/api/v1/globalpedia_pc/studio/stu_key_info', { params });
};

// 详情页About内容（情报接口）
export const queryDetailAbout = (params: { company_id: string }) => {
  return http.post('/api/v1/intelligence_pc/detail/company/about', params);
};

// 详情页Recent News & Activity内容（情报接口）
export const queryDetailNews = (params: { company_id: string }) => {
  return http.post('/api/v1/intelligence_pc/detail/company/news', params);
};

// 详情页Projects-Live Intelligence信息
export const queryDetailProjectsLiveOfIntelligence = (params: { studio_id: string; internal?: boolean }) => {
  return http.get('/api/v1/globalpedia_pc/studio/project_live', { params });
};

// 详情页Projects-Live Internal信息
export const queryDetailProjectsLiveOfInternal = (params: { select_id: string[]; yoy: boolean; mom: boolean }) => {
  // @ts-ignore
  return http({
    url: 'api/v1/globalpedia_pc/studio/project_internal_live',
    method: 'post',
    data: params,
    formatData: (res) => {
      const list = [];
      const resList = res?.list;
      if (Array.isArray(resList) && resList?.length) {
        for (let i = 0, l = resList?.length; i < l; i++) {
          const t = resList?.[i];
          let revenue = null;
          let mau = null;
          let ytmDate = '';
          let mauDate = '';
          const details = t?.details;
          if (Array.isArray(details)) {
            for (let j = 0, l = details?.length; j < l; j++) {
              const k = details?.[j];
              if (k?.metric === 'Gross Revenue YTM') {
                revenue = k?.value;
                ytmDate = k?.date ? k?.date?.slice(0, 7) : '';
                mauDate = k?.date ? k?.date?.slice(0, 7) : '';
              }
              if (k?.metric === 'MAU') {
                mau = k?.value;
                if (k?.date) {
                  ytmDate = k?.date ? k?.date?.slice(0, 7) : '';
                  mauDate = k?.date ? k?.date?.slice(0, 7) : '';
                }
              }
            }
          }
          const obj = {
            genre: t?.genre || '',
            id: t?.game_id || '',
            img_url: t?.cover || '',
            is_new: t?.is_new || false,
            // 这里两个时间是一样的
            mau_date: mauDate, // YYYY-MM
            ytm_date: ytmDate, // YYYY-MM
            name: t?.game_name || '',
            revenue, // number
            mau_list: null, // {platform: string, value: string}[]
            // mau的平台和加总数据
            platform: Array.isArray(t?.platform) ? t?.platform?.join(',') : t?.platform,
            mau,
          };
          list.push(obj);
        }
      }

      return {
        total: res?.total || 0,
        data_time: res?.data_time,
        game_detail: list?.length ? list : null,
      };
    },
  });
};

// 详情页Projects-In Development信息
export const queryDetailProjectsInDev = (params: { studio_id: string }) => {
  return http.get('/api/v1/globalpedia_pc/studio/project_dev', { params });
};

// 详情页 projects tab页 projects列表
export const fetchProjectsOfProjectsTab = (params: { studio_id: string; internal?: boolean }) => {
  return http.get('/api/v1/globalpedia_pc/studio/project/liveList', { params });
};

// 详情页 projects tab页 Total Revenue Trends - Intelligence列表
export const fetchTotalRevenueTrendsOfProjectsTabIntelligence = (params: {
  studio_id: string;
  ids: {
    id: string;
    platform_id: string[];
  }[];
  start_date: string;
  end_date: string;
  internal?: boolean;
}) => {
  return http.post('/api/v1/globalpedia_pc/studio/project/revenueTrend', params, {
    original: true,
  });
};

// 详情页 projects tab页 Total Revenue Trends - Internal列表
export const fetchTotalRevenueTrendsOfProjectsTabInternal = (params: {
  studio_id: string;
  select_id: string[];
  yoy: boolean;
  mom: boolean;
  start_date: string;
  end_date: string;
}) => {
  return http.post('/api/v1/globalpedia_pc/studio_overall/projects/live/internal_revenue_trend', params, {
    original: true,
  });
};

// 详情页 projects tab页 Total Revenue Trends - Intelligence下载
export const downloadTotalRevenueTrendsOfProjectsTabIntelligence = (params: {
  studio_id: string;
  ids: {
    id: string;
    platform_id: string[];
  }[];
  start_date: string;
  end_date: string;
  file_type: number;
  internal?: boolean;
}) => {
  // @ts-ignore
  return http({
    url: '/api/v1/globalpedia_pc/studio/project/revenueTrend_download',
    method: 'post',
    data: params,
    original: true,
    responseType: 'blob',
    download: true,
    errorHandler: true,
  });
};

// 详情页 projects tab页 Total Revenue Trends - Internal下载
export const downloadTotalRevenueTrendsOfProjectsTabInternal = (params: {
  studio_id: string;
  select_id: string[];
  yoy: boolean;
  mom: boolean;
  start_date: string;
  end_date: string;
  file_type: number;
}) => {
  // @ts-ignore
  return http({
    url: '/api/v1/globalpedia_pc/studio_overall/projects/live/internal_revenue_trend_download',
    method: 'post',
    data: params,
    original: true,
    responseType: 'blob',
    download: true,
    errorHandler: true,
  });
};

// 详情页Projects页签Breakdown列表Intelligence信息
export const queryBreakdownIntelligenceList = (params: {
  studio_id: string;
  ids: { id: string; platform_id: string[] | undefined }[];
  order: 'asc' | 'desc';
  order_metric: string;
  internal?: boolean;
}) => {
  return http.post('/api/v1/globalpedia_pc/studio_projects/breakdown', params);
};

// 详情页Projects页签Breakdown列表Intelligence下载
export const queryBreakdownIntelligenceDownLoad = (params: {
  projects_breakdown: {
    studio_id: string;
    ids: { id: string; platform_id: string[] | undefined }[];
    order: 'asc' | 'desc';
    order_metric: string; // 排序字段
  };
  file_type: 1 | 2; // 1: csv 2: excal
  internal?: boolean;
}) => {
  // @ts-ignore
  return http({
    url: '/api/v1/globalpedia_pc/studio_projects/breakdown/download',
    method: 'post',
    data: params,
    original: true,
    responseType: 'blob',
    download: true,
    errorHandler: true,
  });
};

// 详情页Projects页签Breakdown列表Internal下载
export const queryBreakdownInternalDownLoad = (params: {
  order?: 'asc' | 'desc';
  order_metric?: string;
  select_id: string[];
  yoy: boolean;
  mom: boolean;
  studio_id: string;
  file_type: 1 | 2; // 1: csv 2: excal
}) => {
  // @ts-ignore
  return http({
    url: '/api/v1/globalpedia_pc/studio_overall/projects/live/internal_breakdown_download',
    method: 'post',
    data: params,
    original: true,
    responseType: 'blob',
    download: true,
    errorHandler: true,
  });
};

// 详情页Projects页签Overview列表下载
export const queryOverviewDownLoad = (params: {
  project_list_req: {
    studio: string[];
    search: string[];
    sort: string;
    sort_type: 'asc' | 'desc' | '';
  };
  file_type: 1 | 2; // 1: csv 2: excal
  stage?: string;
  no_pps?: boolean;
}) => {
  // @ts-ignore
  return http({
    url: '/api/v1/globalpedia_pc/studio_projects/develop/download',
    method: 'post',
    data: params,
    original: true,
    responseType: 'blob',
    download: true,
    errorHandler: true,
  });
};

// 详情页Projects页签Cost列表信息
export const queryCostList = (params: {
  studio_id: string;
  ids: string[];
  sort_type: 'asc' | 'desc';
  sort: string;
  stage?: string;
}) => {
  return http.post('/api/v1/globalpedia_pc/studio/project/dev_cost', params);
};

// 详情页Projects页签Cost列表下载
export const queryCostDownload = (params: {
  file_type: 1 | 2; // 1: csv, 2: excel
  studio_id: string;
  ids: string[];
  sort: string;
  sort_type: 'asc' | 'desc';
  stage?: string;
}) => {
  // @ts-ignore
  return http({
    url: '/api/v1/globalpedia_pc/studio/project/dev_cost_download',
    method: 'post',
    data: params,
    original: true,
    responseType: 'blob',
    download: true,
    errorHandler: true,
  });
};

// 详情页Projects页签Development页签筛选器列表
export const queryProjectList = (params: { studio_id: string }): Promise<{ id: string; name: string }[]> => {
  return http.get('/api/v1/globalpedia_pc/studio_projects/dev_list', {
    params,
  });
};

// 详情页Management页签 获取Key Issues列表数据
export const queryKeyIssuesOfManagement = (params: { studio_id: string }): Promise<IStudioManagementKeyIssue[]> => {
  return http.get('/api/v1/globalpedia_pc/studio_management/key_issues', {
    params,
  });
};

// 详情页Management页签 获取董事会议列表数据
export const queryMeetingsOfManagement = (params: { studio_id: string }): Promise<IStudioManagementMeeting[]> => {
  return http.get('/api/v1/globalpedia_pc/studio_management/meeting', {
    params,
  });
};

// 详情页Management页签 获取董事会议附件 当前用户是否可以预览的权限
export const queryMeetingsFilePreviewPermissionOfManagement = (params: { studio_id: string }): Promise<boolean> => {
  return http.get('/api/v1/globalpedia_pc/studio_management/check_board_meeting', {
    params,
  });
};

// 详情页Management页签 获取BIDS系统的studio id
export const queryStudioIdOfBIDS = (params: { studio_id: string }): Promise<string> => {
  return http.get('/api/v1/globalpedia_pc/studio_management/get_bids_id', {
    params,
  });
};

// // 详情页Management页签 附件下载
export const downloadAttachmentOfManagement = (params: { path: string; studioID: string }) => {
  // @ts-ignore
  return http({
    url: '/api/v1/globalpedia_pc/studio_management/meeting_file/download',
    method: 'get',
    params,
    original: true,
    responseType: 'blob',
    download: true,
    errorHandler: true,
  });
};

// 详情页Calendar页签筛选器可选时间范围
export const queryCalendarSelectableTime = (params: {
  studio_id: string;
  category?: string;
}): Promise<{
  ms_start_date: string;
  ms_end_date: string;
  mgt_start_date: string;
  mgt_end_date: string;
}> => {
  return http.get('/api/v1/globalpedia_pc/studio/calendar/getSelectableTime', {
    params,
  });
};

// 详情页Calendar页签会议数据
export const queryCalendarList = (params: {
  studio_id: string;
  category?: string;
  start_date: string;
  end_date: string;
  granularity: 'monthly' | 'quarter' | 'year';
}): Promise<{
  no_auth: boolean;
  list:
    | {
        date: string;
        detail: {
          id: string;
          category: 'milestone' | 'management';
          cover: string;
          date: string;
          is_gr: boolean;
          name: string;
          platform: string;
          project_name: string;
        }[];
      }[]
    | null;
}> => {
  return http.get('/api/v1/globalpedia_pc/studio/calendar/calendar_detail', {
    params,
  });
};

// 详情页People页签 获取有数据的时间范围
export const queryDateRangeOfPeople = (params: {
  studio_id: string;
}): Promise<{
  start_date: string;
  end_date: string;
}> => {
  return http.get('/api/v1/globalpedia_pc/studio/people/time_range', {
    params,
  });
};

// 详情页People页签 获取Management Team列表数据
export const queryManagementTeamDataOfPeople = (params: {
  studio_id: string;
}): Promise<{
  list: {
    name: string;
    image_url: string;
    position: string;
  }[];
  update_time: string;
}> => {
  return http.get('/api/v1/globalpedia_pc/studio/people/management_team', {
    params,
  });
};

// 详情页People页签 Headcounts获取全量数据（不包含others）
export const queryAllHeadcountsOfPeople = async (params: {
  file_type: number;
  people_headcounts: {
    studio_id: string;
    type: 1 | 2; // 1: function 2: projects
    start_date: string;
    end_date: string;
    order_metric?: string;
    order?: string;
  };
}): Promise<any> => {
  // @ts-ignore
  return http({
    url: '/api/v1/globalpedia_pc/studio_people/headcounts/download',
    method: 'post',
    data: params,
    original: true,
  });
};

// 详情页People页签 下载Headcounts，目前只有CSV
export const downloadHeadcountsOfPeople = async (params: {
  file_type: number;
  people_headcounts: {
    studio_id: string;
    type: 1 | 2; // 1: function 2: projects
    start_date: string;
    end_date: string;
    order_metric?: string;
    order?: string;
  };
}): Promise<BlobPart> => {
  // @ts-ignore
  return http({
    url: '/api/v1/globalpedia_pc/studio_people/headcounts/download',
    method: 'post',
    data: params,
    original: true,
    responseType: 'blob',
    download: true,
    errorHandler: true,
  });
};

// 详情页People页签 Headcount Cost获取全量数据（不包含others）
export const queryAllHeadcountCostOfPeople = async (params: {
  file_type: number;
  people_headcounts: {
    studio_id: string;
    type: 1 | 2; // 1: function 2: projects
    start_date: string;
    end_date: string;
    order_metric?: string;
    order?: string;
  };
}): Promise<any> => {
  // @ts-ignore
  return http({
    url: '/api/v1/globalpedia_pc/studio_people/headcounts_cost/download',
    method: 'post',
    data: params,
    original: true,
  });
};

// 详情页People页签 下载Headcount Cost，目前只有CSV
export const downloadHeadcountCostOfPeople = async (params: {
  file_type: number;
  people_headcounts: {
    studio_id: string;
    type: 1 | 2; // 1: function 2: projects
    start_date: string;
    end_date: string;
    order_metric?: string;
    order?: string;
  };
}): Promise<BlobPart> => {
  // @ts-ignore
  return http({
    url: '/api/v1/globalpedia_pc/studio_people/headcounts_cost/download',
    method: 'post',
    data: params,
    original: true,
    responseType: 'blob',
    download: true,
    errorHandler: true,
  });
};

// 详情页People页签 5Y Headcounts获取全量数据（不包含others）
export const queryAll5YHeadcountsOfPeople = async (params: {
  file_type: number;
  people_headcounts: {
    studio_id: string;
    type: 1 | 2; // 1: function 2: projects
    order_metric?: string;
    order?: string;
  };
}): Promise<any> => {
  // @ts-ignore
  return http({
    url: '/api/v1/globalpedia_pc/studio_people/5y_headcounts/download',
    method: 'post',
    data: params,
    original: true,
  });
};

// 详情页People页签 下载5Y Headcounts，目前只有CSV
export const download5YHeadcountsOfPeople = async (params: {
  file_type: number;
  people_headcounts: {
    studio_id: string;
    type: 1 | 2; // 1: function 2: projects
    order_metric?: string;
    order?: string;
  };
}): Promise<BlobPart> => {
  // @ts-ignore
  return http({
    url: '/api/v1/globalpedia_pc/studio_people/5y_headcounts/download',
    method: 'post',
    data: params,
    original: true,
    responseType: 'blob',
    download: true,
    errorHandler: true,
  });
};

// 详情页 People 页签 Headcounts模块数据
export const queryHeadcountsList = (params: {
  studio_id: string;
  start_date: string; // 2023-01-01
  end_date: string; // 2023-12-01
  type: 1 | 2; // 1: function 2: projects
  order_metric?: string;
  order?: string;
}) => {
  // @ts-ignore
  return http({
    url: '/api/v1/globalpedia_pc/studio_people/headcounts',
    method: 'post',
    data: params,
    original: true,
  });
};

// 详情页 People 页签 Headcount Cost模块数据
export const queryHeadcountCostList = (params: {
  studio_id: string;
  start_date: string; // 2023-01-01
  end_date: string; // 2023-12-01
  type: 1 | 2; // 1: function 2: projects
  order_metric?: string;
  order?: string;
}) => {
  // @ts-ignore
  return http({
    url: '/api/v1/globalpedia_pc/studio_people/headcounts_cost',
    method: 'post',
    data: params,
    original: true,
  });
};

// 详情页 People 页签 5Y Headcounts模块数据
export const queryFiveYearHeadcountsList = (params: {
  studio_id: string;
  type: 1 | 2; // 1: function 2: projects
  order_metric?: string;
  order?: string;
}): Promise<{
  list: any[];
  update_time: string;
}> => {
  // @ts-ignore
  return http({
    url: '/api/v1/globalpedia_pc/studio_people/5y_headcounts',
    method: 'post',
    data: params,
    original: true,
  });
};

// 详情页 Finance页签 获取有数据的时间范围
export const queryDateRangeOfFinance = (params: {
  studio_id: string;
}): Promise<{
  start_date: string;
  end_date: string;
}> => {
  return http.get('/api/v1/globalpedia_pc/studio_finance/time_range', {
    params,
  });
};

// 详情页 Finance页签 获取projects筛选器的下拉列表数据
export const queryProjectsOfFinance = (params: {
  studio_id: string;
  start_date: string;
  end_date: string;
}): Promise<IStudioOverallDetailsProject[]> => {
  return http.get('/api/v1/globalpedia_pc/studio_finance/project_arr', {
    params,
  });
};

// 详情页 Finance页签 获取Revenue Completion模块 双轴柱线图数据查询
export const queryRevenueCompletionBarLineDataOfFinance = (params: {
  studio_id: string;
  start_date: string;
  end_date: string;
}): Promise<{
  trend: IStudioOverallDetailsRevenueProfitCompletionTrendData[];
  table: IStudioOverallDetailsRevenueProfitCompletionTableData[];
  total: number;
}> => {
  return http.get('/api/v1/globalpedia_pc/studio_finance/revenue_completion', {
    params,
  });
};

// 详情页 Finance页签 获取Revenue Completion模块 获取表格全部数据（others替换为 具体的project）用于PDF下载
export const queryAllRevenueCompletionBarLineDataOfFinance = (params: {
  studio_id: string;
  start_date: string;
  end_date: string;
  file_type: number;
}): Promise<{
  trend: IStudioOverallDetailsRevenueProfitCompletionTrendData[];
  table: IStudioOverallDetailsRevenueProfitCompletionTableData[];
  total: number;
}> => {
  return http.get('/api/v1/globalpedia_pc/studio_finance/revenue_completion/download', {
    params,
  });
};

// 详情页 Finance页签 获取Revenue Completion模块 CSV下载
export const downloadRevenueCompletionOfFinance = (params: {
  studio_id: string;
  start_date: string;
  end_date: string;
  file_type: number;
}): Promise<BlobPart> => {
  // @ts-ignore
  return http({
    url: '/api/v1/globalpedia_pc/studio_finance/revenue_completion/download',
    method: 'get',
    params,
    original: true,
    responseType: 'blob',
    download: true,
    errorHandler: true,
  });
};

// 详情页 Finance页签 获取Profit Completion模块 双轴柱线图数据查询
export const queryProfitCompletionBarLineDataOfFinance = (params: {
  studio_id: string;
  start_date: string;
  end_date: string;
}): Promise<{
  trend: IStudioOverallDetailsRevenueProfitCompletionTrendData[];
  table: IStudioOverallDetailsRevenueProfitCompletionTableData[];
  total: number;
}> => {
  return http.get('/api/v1/globalpedia_pc/studio_finance/profit_completion', {
    params,
  });
};

// 详情页 Finance页签 获取Profit Completion模块 获取表格全部数据（others替换为 具体的project）用于PDF下载
export const queryAllProfitCompletionBarLineDataOfFinance = (params: {
  studio_id: string;
  start_date: string;
  end_date: string;
  file_type: number;
}): Promise<{
  trend: IStudioOverallDetailsRevenueProfitCompletionTrendData[];
  table: IStudioOverallDetailsRevenueProfitCompletionTableData[];
  total: number;
}> => {
  return http.get('/api/v1/globalpedia_pc/studio_finance/profit_completion/download', {
    params,
  });
};

// 详情页 Finance页签 获取Profit Completion模块 CSV下载
export const downloadProfitCompletionDataOfFinance = async (params: {
  studio_id: string;
  start_date: string;
  end_date: string;
  file_type: number;
}): Promise<BlobPart> => {
  // @ts-ignore
  return http({
    url: '/api/v1/globalpedia_pc/studio_finance/profit_completion/download',
    method: 'get',
    params,
    original: true,
    responseType: 'blob',
    download: true,
    errorHandler: true,
  });
};

// 详情页 Finance页签 获取Middle - Long Time Financials模块 数据
export const queryMiddleLongTimeFinancialsDataOfFinance = (params: {
  studio_id: string;
}): Promise<{
  trend: IStudioOverallDetailsRevenueProfitCompletionTrendData[];
  update_time: string;
}> => {
  return http.get('/api/v1/globalpedia_pc/studio_finance/long_time_financials', {
    params,
  });
};
// 详情页 Finance页签 获取Middle - Long Time Financials模块 CSV下载
export const downloadMiddleLongTimeFinancialsDataOfFinance = async (params: {
  studio_id: string;
  file_type: number;
}): Promise<BlobPart> => {
  // @ts-ignore
  return http({
    url: '/api/v1/globalpedia_pc/studio_finance/long_time_financials/download',
    method: 'get',
    params,
    original: true,
    responseType: 'blob',
    download: true,
    errorHandler: true,
  });
};
